/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { observer } from 'mobx-react';
import { makeApi, URLS } from 'Utils/apiUtil';
import userDetail from 'Stores/userDetail';
import { InputBoxWithSuggestion } from '../shared-component/inputBoxWithSuggestion';

let cancelCompanyNameCall = null;
const CompanyName = observer(props => {
  const suggestionKey = 'companyName';
  const [inputVal, setInputVal] = React.useState('');
  const [suggestionList, setSuggestionList] = React.useState([]);
  const [selectedItem, setSelectedItem] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [noMatchFound, setNoMatchFound] = React.useState(false);

  const generateListSearchArr = (list = [], searchTerm) => {
    if (list.length) {
      let modifyListByExactMatch = [];
      if (searchTerm.includes('.')) {
        modifyListByExactMatch.push(
          ...list.filter(
            item =>
              (item.domain || '').toLowerCase() === searchTerm.toLowerCase(),
          ),
        );
        modifyListByExactMatch.push(
          ...list.filter(
            item =>
              (item.domain || '').toLowerCase() !== searchTerm.toLowerCase(),
          ),
        );
      } else {
        modifyListByExactMatch = list;
      }

      const newList = modifyListByExactMatch.map(item => {
        const newObj = {};
        newObj.pName = item.domain;
        newObj.orgName = item.name;
        newObj.name = item.domain;
        return newObj;
      });
      setSuggestionList(newList);
    } else {
      setSuggestionList([]);
    }
  };

  const getSuggestion = () => {
    const config = {
      url: URLS.companyNameWithDomainV2,
      method: 'POST',
      data: {
        q: inputVal,
      },
    };
    if (cancelCompanyNameCall !== null) {
      cancelCompanyNameCall('cancel');
      cancelCompanyNameCall = null;
    }
    const companyNameCancelCallback = value => {
      cancelCompanyNameCall = value;
    };
    setLoading(true);
    makeApi(config, false, companyNameCancelCallback)
      .then(response => {
        setLoading(false);
        generateListSearchArr(response.data, inputVal);
        if (response.data && response.data.length === 0) setNoMatchFound(true);
      })
      .catch(error => {
        console.log('suggestionList error ', error);
      });
  };

  React.useEffect(() => {
    setNoMatchFound(false);
    if (inputVal === '') setSuggestionList([]);
    else getSuggestion();
  }, [inputVal]);

  return (
    <InputBoxWithSuggestion
      inputVal={inputVal}
      placeholder="Company Name"
      setInputVal={setInputVal}
      suggestionList={suggestionList}
      noMatchFound={noMatchFound}
      setNoMatchFound={setNoMatchFound}
      setSelectedItem={setSelectedItem}
      selectedItem={selectedItem}
      suggestionKey={suggestionKey}
      {...props}
    />
  );
});

export { CompanyName };
export default CompanyName;
